let date = new Date();
let dateN = new Date();
dateN.setDate(1);
export default {
    dates: [
        '' + (dateN.getDate() > 9 ? '' : '0') + dateN.getDate() + '.' + (dateN.getMonth() > 8 ? '' : '0') + (dateN.getMonth() + 1) + '.' + dateN.getFullYear(),
        '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear()
    ],
    AccountId: '',
    SubAccountId: '',
    ContragentId: '',
    ContragentName: '',
    CurrencyId: '',
    PaymentAccountId: '',
    WithTurns: false,
    WithDocumens: false,
}